import { Injectable, ElementRef } from '@angular/core';
import { KeyCodeService } from './key-code.service';

@Injectable()
export class ComboService {
  constructor(private _keyCodeService: KeyCodeService) {}
  buildTermToSearch(element: ElementRef, key: KeyboardEvent): string {
    let termsToSearch = '';
    if (element.nativeElement.value.toString().trim() === '') {
      element.nativeElement.value = '';
      return '';
    }
    if (this._keyCodeService.isSpecialKey(key.keyCode)) {
      element.nativeElement.value = element.nativeElement.value.toString();
      return '';
    }
    if (key.keyCode === 8) {
      termsToSearch = element.nativeElement.value
        .toString()
        .substring(0, element.nativeElement.value.length - 1);
    } else {
      termsToSearch = element.nativeElement.value + key.key;
    }
    return termsToSearch;
  }
}
